import sha256 from 'crypto-js/sha256';
import axios from 'axios';
import {isNullOrUndefined} from 'cgil-html-utils';
import { getLog } from '../config';

const log = getLog('cgil-Login', 4, 1);

export const getPasswordHash = password => sha256(password);


export const getToken = async (baseServerUrl, username, passwordHash) => {
  const data = {
    username,
    password_hash: `${passwordHash}`,
  };
  log.t('# IN getToken() data:', data);
  let response = null;
  try {
    response = await axios.post(`${baseServerUrl}/token/login`, data); // .then((response) => {
    log.l('getToken() axios.post Success ! response :', response.data);
    if (response.status === 200) {
      if (typeof Storage !== 'undefined') {
        // Code for localStorage/sessionStorage.
        sessionStorage.setItem('goapi_jwt_session_token', response.data.JWT_token);
        sessionStorage.setItem('goapi_session_token', response.data.session_token);
        sessionStorage.setItem('goapi_idgouser', response.data.idgouser);
        sessionStorage.setItem('goapi_name', response.data.name);
        sessionStorage.setItem('goapi_email', response.data.email);
        sessionStorage.setItem('goapi_isadmin', response.data.isadmin);
        sessionStorage.setItem('goapi_isinsdol', response.data.isinsdol);
        sessionStorage.setItem('goapi_idsession', response.data.idsession);
        sessionStorage.setItem('goapi_date_expiration', response.data.date_expiration);
        if (!isNullOrUndefined(response.data.commune_ofsid)) {
          sessionStorage.setItem('goapi_commune_ofsid', response.data.commune_ofsid);
        }
        if (!isNullOrUndefined(response.data.minx)) {
          const userExtent = [
            response.data.minx,
            response.data.miny,
            response.data.maxx,
            response.data.maxy,
          ];
          sessionStorage.setItem('goapi_user_extent', userExtent);
        }
      }
      return response.data;
    }
    log.w('axios get a bad status ! response was:', response);
  } catch (e) {
    log.e('getToken() ## Try Catch ERROR ## error :', e);
    log.e('axios response was:', e.response);
    return e;
  }
};
export const getTokenStatus = async (baseServerUrl) => {
  log.t('# IN getJwtTokenStatus() ');
  axios.defaults.headers.common.Authorization =
                                `Bearer ${sessionStorage.getItem('goapi_jwt_session_token')}`;
  try {
    const res = await axios.get(`${baseServerUrl}/token/status`);
    log.l('getJwtTokenStatus() axios.get Success ! response :', res);
    return res.data;
  } catch (error) {
    log.e('getJwtTokenStatus() ## axios.post ERROR ## error :', error);
    return error;
  }
};

export const clearSessionStorage = () => {
  // Code for localStorage/sessionStorage.
  sessionStorage.removeItem('goapi_jwt_session_token');
  sessionStorage.removeItem('goapi_session_token');
  sessionStorage.removeItem('goapi_idgouser');
  sessionStorage.removeItem('goapi_name');
  sessionStorage.removeItem('goapi_email');
  sessionStorage.removeItem('goapi_isadmin');
  sessionStorage.removeItem('goapi_isinsdol');
  sessionStorage.removeItem('goapi_idsession');
  sessionStorage.removeItem('goapi_date_expiration');
  sessionStorage.removeItem('goapi_commune_ofsid');
  sessionStorage.removeItem('goapi_user_extent');
};

export const logoutAndResetToken = (baseServerUrl) => {
  log.t('# IN logoutAndResetToken()');
  axios.defaults.headers.common.Authorization =
                                `Bearer ${sessionStorage.getItem('goapi_jwt_session_token')}`;
  axios.get(`${baseServerUrl}/token/logout`)
    .then((response) => {
      log.l('logoutAndResetToken() axios.get Success ! response :', response);
      clearSessionStorage();
    })
    .catch((error) => {
      log.e('logoutAndResetToken() ## axios.get ERROR ## error :', error);
    });
};

export const doesCurrentSessionExist = () => {
  // log.t('# IN doesCurrentSessionExist() ');
  if (sessionStorage.getItem('goapi_date_expiration') !== null) {
    const dateExpire = new Date(sessionStorage.getItem('goapi_date_expiration'));
    const now = new Date();
    if (now > dateExpire) {
      clearSessionStorage();
      log.w('# IN doesCurrentSessionExist() SESSION EXPIRED');
      return false;
    }
    // maybe check if token is still valid on server
    return true;
  }
  // sessionStorage.getItem('goapi_date_expiration') was null
  log.w('# IN doesCurrentSessionExist() SESSION EXPIRED');
  return false;
};

export const getLocalJwtTokenAuth = () => {
  if (doesCurrentSessionExist()) {
    return `Bearer ${sessionStorage.getItem('goapi_jwt_session_token')}`;
  }
  return '';
};

export const getUserEmail = () => {
  if (doesCurrentSessionExist()) {
    return `${sessionStorage.getItem('goapi_email')}`;
  }
  return '';
};

export const getUserExtent = () => {
  log.t('# IN getUserExtent() ');
  if (doesCurrentSessionExist()) {
    const extent = sessionStorage.getItem('goapi_user_extent').split(',').map(Number);
    log.w('# IN getUserExtent() ', extent);
    return extent;
  }
  return 0;
};

export const getUserId = () => {
  if (doesCurrentSessionExist()) {
    return parseInt(`${sessionStorage.getItem('goapi_idgouser')}`, 10);
  }
  return 0;
};

export const getUserName = () => {
  if (doesCurrentSessionExist()) {
    if (sessionStorage.getItem('goapi_isinsdol') === 'true') {
      return `SDOL-${sessionStorage.getItem('goapi_name')}`;
    }
    return `${sessionStorage.getItem('goapi_name')}`;
  }
  return '';
};


export const getUserIsAdmin = () => {
  if (doesCurrentSessionExist()) {
    return (sessionStorage.getItem('goapi_isadmin') === 'true');
  }
  return false;
};

export const getUserIsInSdol = () => {
  if (doesCurrentSessionExist()) {
    return (sessionStorage.getItem('goapi_isinsdol') === 'true');
  }
  return true; // vaut mieux dire que user est in sdol par default moins de degat
};

export const getUserCommuneOfsId = () => {
  if (doesCurrentSessionExist()) {
    return parseInt(`${sessionStorage.getItem('goapi_commune_ofsid')}`, 10);
  }
  return 0; // vaut mieux dire que user est in sdol par default moins de degat
};
